import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import useToken from '../hooks/useToken';

import DokkioAPI from '../services/DokkioAPI';

import PDFViewer from './PDFViewer';

export const IntegrationItemPDF = ({
  accountID,
  children,
  fitToWidth,
  integrationItem: {
    integrationID,
    remoteID,
  },
  setShowFitToWidthControl,
}) => {
  const [token] = useToken();
  const API = new DokkioAPI({ token });

  // eslint-disable-next-line arrow-body-style
  useEffect(() => {
    return () => setShowFitToWidthControl(false);
  }, []);

  const getPDFURL = () => {
    if (token && token.accessToken) {
      return API.integrationItemPDFURL({ integrationID, remoteID });
    }
    return DokkioAPI.publicIntegrationItemPDFURL({ integrationID, remoteID });
  };

  const fetchInfo = () => API.graphQL(`
    query integrationItemPDFInfo (
      $accountID: DokkioID
      $integrationID: DokkioID!
      $remoteID: ID!
    ) {
      integrationItemPDFInfo (
        accountID: $accountID
        integrationID: $integrationID
        remoteID: $remoteID
      ) {
        bytes
      }
    }
  `, {
    variables: {
      accountID,
      integrationID,
      remoteID,
      noAuth: Boolean(accountID),
    },
  });

  return (
    <PDFViewer
      key={`${fitToWidth}-${integrationID}-${remoteID}`}
      fetchInfo={fetchInfo}
      fitToWidth={fitToWidth}
      onDocumentComplete={() => setShowFitToWidthControl(true)}
      src={getPDFURL()}
    >
      {children}
    </PDFViewer>
  );
};

IntegrationItemPDF.propTypes = {
  accountID: PropTypes.string,
  children: PropTypes.node.isRequired,
  fitToWidth: PropTypes.bool,
  integrationItem: PropTypes.shape({
    integrationID: PropTypes.string.isRequired,
    remoteID: PropTypes.string.isRequired,
  }).isRequired,
  setShowFitToWidthControl: PropTypes.func,
};

IntegrationItemPDF.defaultProps = {
  accountID: null,
  fitToWidth: false,
  setShowFitToWidthControl: () => null,
};

export default IntegrationItemPDF;
